import { MARKET } from '@/common/constants/markets';
import { TMarket } from '@/common/constants/markets';
import { IMenhirBenefitSlug } from '@/common/integrations/menhir/employee/benefits/benefits.types';
import { benefitRouteTypeMapping } from '@/common/utils/benefits';
import { IMovementsParams } from '@/web/hooks/useMovements';

export function getMovementsParams({
  product,
  benefit,
  budget,
}: {
  product?: string;
  benefit?: IMenhirBenefitSlug;
  budget?: string;
}): IMovementsParams {
  switch (product) {
    case 'meal':
      return {
        pocketType: 'meals',
      };
    case 'benefits':
      return {
        pocketType: 'benefits',
        category: benefit ? benefitRouteTypeMapping[benefit] : undefined,
      };
    case 'budgets':
      return {
        category: 'budgets',
        pocketIds: budget ? [budget] : undefined,
      };
    case 'ewa':
      return {
        category: 'budgets',
        subcategory: 'ewa_request',
      };
    default:
      return {};
  }
}

export function getOperationsUsage({
  market,
  product,
}: {
  market: TMarket;
  product?: string;
}) {
  if (market === MARKET.IT) {
    if (product === 'meal') {
      return 'meal-voucher';
    }

    if (product === 'benefits') {
      return 'benefits-voucher';
    }
  }

  return 'all';
}
